import React from "react";
import Layout from "../components/common/Layout";
import Banner from "../components/home/Banner";
import ProjectLogos from "../components/home/ProjectLogos";
import Testimonials from "../components/home/Testimonials";
import BlogSection from "../components/home/BlogSection";
import MediaSection from "../components/home/MediaSection";
import Ongoing from "../components/projects/Ongoing";
import OngoingCommercial from "../components/projects/commercial/Ongoing";
import { getSEOData } from "../utils/seo";

export default () => {
  const seoData = getSEOData("home");
  
  return (
    <Layout seoData={seoData}>
      <Banner />
      <Ongoing />
      <OngoingCommercial />
      <ProjectLogos />
      <section className="section-pad border-bottom">
      <div className="container-lg container-fluid">
        <h3 className="section-title text-center">A Rich Lineage Driven By Farsighted Vision, Innovation And Integrity</h3>
        <div className="row text-center">
        We are a revolutionary brand that is steeped in tradition, trust and transparency. Fuelled by high degrees of passion and innovation, we relentlessly champion the rights and aspirations of discerning homebuyers.
        </div>
        <br />
        <div className="row text-center">
        Over the years we have become a household name for residential and commercial infrastructure in Tamil Nadu. Brand Baashyaam today stands tall among peers for being an industry pioneer that brings fresh ideas, novel concepts and unseen lifestyle experiences.
        </div>
        <br />
        <div className="text-center">
        The brands portfolio of diverse projects stands grand testimony to it. Proof of this is the enviable range of projects across categories, right from Affordable Housing, Independent Villas, Premium Living spaces to <a href='/ongoing-projects/' target='_blank' style={{ display: 'inline-block' }}>Luxury apartments in Chennai</a>.
        </div>
      </div>
    </section>
      <Testimonials />
      <BlogSection />
      <MediaSection />
    </Layout>
  );
};
